import apiCall from "src/Candidate/helpers/apiCall";

export const getPrivacyPolicy = async () => {
  try {
    const endpoint = "/legal/privacy-policy";

    const response = await apiCall(endpoint, "GET");

    return response?.data ?? response;
  } catch (error: any) {
    throw new Error(error.message || "Failed to fetch privacy policy");
  }
};

export const getCookiePolicy = async () => {
  try {
    const endpoint = "/legal/cookie-policy";

    const response = await apiCall(endpoint, "GET");

    return response?.data ?? response;
  } catch (error: any) {
    throw new Error(error.message || "Failed to fetch cookie policy");
  }
};

export const getTermsOfService = async () => {
  try {
    const endpoint = "/legal/terms-of-service";

    const response = await apiCall(endpoint, "GET");

    return response?.data ?? response;
  } catch (error: any) {
    throw new Error(error.message || "Failed to fetch terms of service");
  }
};
